export default "__VITE_ASSET__Df3zWIS1__"